import { render, staticRenderFns } from "./Turntable.vue?vue&type=template&id=032361b4&scoped=true&"
import script from "./Turntable.vue?vue&type=script&lang=js&"
export * from "./Turntable.vue?vue&type=script&lang=js&"
import style0 from "./Turntable.vue?vue&type=style&index=0&id=032361b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032361b4",
  null
  
)

export default component.exports